import groupEventListener from "@/store/plugins/group.event.listener";
import roomUXEventListener from "@/store/plugins/room.ux.event.listener";
import roomDocEventListener from "@/store/plugins/room.doc.event.listener";
import roomLmsEventListener from "@/store/plugins/room.lms.event.listener";
import roomCBTEventListener from "@/store/plugins/room.cbt.event.listener";
import roomCallEventListener from "@/store/plugins/room.call.event.listener";
import roomChatBotEventListener from "@/store/plugins/room.chatBot.event.listener";
import roomExamEventListener from "@/store/plugins/room.exam.event.listener";
import roomFileEventListener from "@/store/plugins/room.file.event.listener";
import roomMediaEventListener from "@/store/plugins/room.media.event.listener";
import roomGroupEventListener from "@/store/plugins/room.group.event.listener";
import roomSettingEventListener from "@/store/plugins/room.setting.event.listener";
import roomNoticeEventListener from "@/store/plugins/room.notice.event.listener";
import roomCommonEventListener from "@/store/plugins/room.common.event.listener";
import roomRecordEventListener from "@/store/plugins/room.record.event.listener";
import roomStickerEventListener from "@/store/plugins/room.sticker.event.listener";
import roomQuestionEventListener from "@/store/plugins/room.question.event.listener";
import roomShareNoteEventListener from "@/store/plugins/room.shareNote.event.listener";
import roomCallStreamEventListener from "@/store/plugins/room.call.stream.event.listener";
import roomURLShareEventListener from "@/store/plugins/room.urlshare.event.listener";
import roomMeetingNoteEventListener from "@/store/plugins/room.meetingNote.event.listener";
import camstudyEventListener from "@/store/plugins/camstudy.event.listener";
import roomCoordiEventListener from "@/store/plugins/room.coordi.event.listener";

export default function roomEventListener(room) {
  return store => {
    groupEventListener(room)(store)
    roomUXEventListener(room)(store)
    roomDocEventListener(room)(store)
    roomLmsEventListener(room)(store)
    roomCBTEventListener(room)(store)
    roomCallEventListener(room)(store)
    roomChatBotEventListener(room)(store)
    roomExamEventListener(room)(store)
    roomFileEventListener(room)(store)
    roomMediaEventListener(room)(store)
    roomGroupEventListener(room)(store)
    roomCommonEventListener(room)(store)
    roomRecordEventListener(room)(store)
    roomNoticeEventListener(room)(store)
    roomSettingEventListener(room)(store)
    roomStickerEventListener(room)(store)
    roomQuestionEventListener(room)(store)
    roomShareNoteEventListener(room)(store)
    roomCallStreamEventListener(room)(store)
    roomURLShareEventListener(room)(store)
    roomMeetingNoteEventListener(room)(store)
    camstudyEventListener(room)(store)
    roomCoordiEventListener(room)(store)
  }
}
